import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import NumberLink from 'components/NumberLink'
import useViewport from 'hooks/useViewport'

import Base from '../Base'
import RatingBreakdownTooltip from './components/RatingBreakdownTooltip'

import classes from './Link.module.scss'

const TYPOGRAPHY_SIZES = {
  small: 'tight-xxs',
  medium: 'tight-xs',
  large: 'body-sm',
}

/** @type {import("./types").default} */
const Link = ({
  average = 0,
  className,
  hideTotals,
  isCompact,
  href,
  totals = 0,
  size = 'small',
  ratings,
  ratingsHrefs,
  ...props
}) => {
  const { up } = useViewport()
  const hasTooltip = totals > 0 && ratings && up('md')

  const Rating = () => {
    const hasAverage = !!average
    const hasLink = !!href
    const Component = hasLink ? 'a' : 'div'
    const disabled = true

    return (
      <Component
        data-testid="listing-item_data_overall-rating_stars"
        className={clsx('RatingLink', classes.root, classes[size], className, disabled && classes.disabled)}
        {...props}
      >
        <Base
          size={size}
          average={average}
          hideAverage={!hasAverage}
          isCompact={isCompact}
          RatingStarsProps={{
            classes: { activeStar: hasLink && classes.activeStar, halfStar: classes.halfStar },
          }}
        />
        {!hideTotals && (
          <NumberLink
            value={totals}
            className={clsx(classes.totals, hasAverage ? classes.totalsLink : classes.nullAverage, {
              [classes.noHover]: !hasLink,
            })}
            variant={TYPOGRAPHY_SIZES[size]}
          />
        )}
      </Component>
    )
  }

  return hasTooltip ? (
    <RatingBreakdownTooltip ratings={ratings} ratingsHrefs={ratingsHrefs} ctaHref={totals > 7 ? href : undefined}>
      <Rating />
      <Icon className={classes.chevron} icon={['fas', 'chevron-down']} size="14" />
    </RatingBreakdownTooltip>
  ) : (
    <Rating />
  )
}

export default Link
